<template>
    <div class="wrap">
        <!-- Map -->
        <div id="map">
          <v-card color="blue" class="card-status px-2" v-if="statusSharing">
            <v-card-text class="pa-0 body-2 white--text font-weight-bold">
              <span class="pl-1">Đang chia sẻ lộ trình</span>
              <v-btn fab dark small outline color="white" class="cancel-sharing mr-0" @click="stopSharedLocation">
                <v-icon dark>close</v-icon>
              </v-btn>
            </v-card-text>
          </v-card>
        </div>
        <!-- History Player -->
        <div :class="`text-xs-center player ${$vuetify.breakpoint.lgAndUp ? `lg` : `md`}`">
            <v-card tile v-if="selectedVehicle && isViewHistory">
                <v-list>
                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                <b>{{selectedVehicle.plate}}</b>&nbsp;&nbsp;
                            </v-list-tile-title>
                        </v-list-tile-content>
                        <v-spacer></v-spacer>
                        <!-- <v-list-tile-action>
                            <datetime
                                v-model="historyFromDate"
                                input-id="startDate"
                                type="datetime"
                                format="yyyy-MM-dd, HH:mm"
                            >
                                <label for="startDate" slot="before">Từ:</label>
                            </datetime>
                        </v-list-tile-action>
                        <v-list-tile-action>
                            <datetime
                                v-model="historyToDate"
                                input-id="endDate"
                                type="datetime"
                                format="yyyy-MM-dd, HH:mm"
                            >
                                <label for="endDate" slot="before">Đến:</label>
                            </datetime>
                        </v-list-tile-action> -->
                        <v-list-tile-action>
                            <date-range-picker
                              dense
                              ref="picker"
                              v-model="historyDate"
                              class="date-rangepicker px-2"
                              :class="{'disabled-apply': historyMaxDay > 6}"
                              :locale-data="{ firstDay: 1, format: 'yyyy/mm/dd HH:MM' }"
                              :ranges="false"
                              :time-picker="true"
                              :show-dropdowns="true"
                              @update="updateHistoryDateRange"
                              @select="selectHistoryDateRange"
                            />
                        </v-list-tile-action>
                        <v-list-tile-action>
                            <a
                                @click="SET_VIEW_HISTORY_DETAIL_STATE(true)"
                                class="blue--text mini-text"
                            >Chi tiết hành trình</a>
                        </v-list-tile-action>
                        <v-list-tile-action style="min-width: 40px">
                            <v-btn icon @click="closeHistory()">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-list-tile-action>
                    </v-list-tile>
                    <div v-if="totalPoints > 0">
                        <v-layout row wrap>
                            <v-btn icon @click="playBack()">
                                <v-icon v-if="!historySlider.isPlayback">play_arrow</v-icon>
                                <v-icon v-if="historySlider.isPlayback">pause</v-icon>
                            </v-btn>
                            <v-slider
                                v-model="historySlider.currentPoint"
                                :min="0"
                                :max="totalPoints-1"
                                @change="sliderValueChanged()"
                                color="blue"
                                class="historySlider"
                            ></v-slider>
                            <v-btn icon @click="changeSpeed">{{historySlider.stepSpeed}}x</v-btn>
                        </v-layout>
                    </div>
                </v-list>
            </v-card>
        </div>
        <!-- Change map type -->
        <div class="map-type">
          <v-menu top offset-y :close-on-content-click="false">
            <v-btn
              color="orange darken-2"
              dark
              slot="activator"
              small
              fab
            >
              <v-icon size="24px">layers</v-icon>
            </v-btn>
            <v-list>
              <v-radio-group v-model="mapType" class="mt-0">
                <v-list-tile
                  v-for="(item, index) in menuMapType"
                  :key="index"
                >
                  <!-- <v-list-tile-title>{{ item.label }}</v-list-tile-title> -->
                    <v-radio
                      color="orange darken-2"
                      :label="item.label"
                      :value="item.value"
                    ></v-radio>
                </v-list-tile>
              </v-radio-group>
            </v-list>
          </v-menu>
        </div>
        <!-- Get location -->
        <div class="get-location">
            <!-- <img :src="`/static/icons/map/${getMaptypeName()}.png`" alt="MapType"> -->
            <v-btn fab small @click="getMyLocation()" class="btn-location">
                <v-icon>my_location</v-icon>
            </v-btn>
        </div>
    </div> 
</template>

<script>
import moment from 'moment';
// import * as MapUtil from '@/utils/maputil';
import * as DateTimeUtil from '@/utils/datetime';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import mixinMap from '@/mixins/maputil';

export default {
  name: 'google-map',
  components: {
    Datetime,
    DateRangePicker
  },

  
  mixins: [mixinMap],

  data () {
    return {
      // Map
      mapType: 'vietmap',
      mapLayer: null,
      map: null,
      menuMapType: [
        { label: 'Vietmap', value: 'vietmap' },
        { label: 'Google map', value: 'roadmap' },
        { label: 'Google map vệ tinh', value: 'hybrid' },
      ],

      // Monitor
      monitorVehicles: [],
      monitorMarkers: {},
      monitorMarkerCluster: null,
      monitorFocusVehicle: null,
      monitorInterval: null,
      monitorIntervalSecond: 1000 * 10,

      // History
      historyCalendarDialog: false,
      historyDate: {
        startDate: moment()
          .startOf('day'),
        endDate: moment()
          .endOf('day')
      },
      historyFromDate: moment()
        .startOf('day')
        .format(),
      historyToDate: moment()
        .endOf('day')
        .format(),
      historyMapLayer: {
        vehicleMarker: null,
        polyline: null,
        overspeedLines: [],
        stoppedMarkers: []
      },
      historyMaxDay: 6,
      historySlider: {
        isPlayback: false,
        stepSpeed: 1,
        currentPoint: 0
      },
      historyInterval: null,
      historyIdleTime: 2000,

      // Display
      display: {
        showGeofences: false,
        showPopup: true
      },

      // My location
      myLocation: {
        marker: null,
        circle: null
      },

      statusSharing: false,
      isDrawFinishMap: false
    };
  },

  computed: {
    ...mapGetters([
      'vehicles',
      'selectedVehicle',
      'lastWaypointUpdateTime',
      'isViewHistory',
      'tripReporting'
    ]),
    // History
    historyWaypoints () {
      let trips = [];
      if (this.tripReporting.length > 0) {
        // console.log(this.tripReporting);
        this.tripReporting.map(a => {
          trips = trips.concat(a.points);
          return 0;
        });
      }
      return trips;
    },
    totalPoints () {
      return this.historyWaypoints.length;
    },
    stoppedPoints () {
      let points = [];

      if (this.tripReporting.length > 0) {
        this.tripReporting.map((trip, index) => {
          let stoppedPoint = null;
          if (index === 0) {
            stoppedPoint = trip.points[0];
          } else {
            stoppedPoint = trip.prevTripEnd;
          }
          // trip.points[0];// trip.prevTripEnd;
          points.push(stoppedPoint);

          if (index > 0) {
            let startPoint = trip.prevTripEnd;
            let endPoint = trip.points[0];

            let duration = DateTimeUtil.formatSecondToDuration(
              endPoint.time - startPoint.time
            );
            stoppedPoint.idle = duration;

            let startTime = DateTimeUtil.formatSecondToHHmm(startPoint.time);
            let endTime = DateTimeUtil.formatSecondToHHmm(endPoint.time);
            stoppedPoint.duration = `${startTime} - ${endTime}`;
          }

          if (index === this.tripReporting.length - 1) {
            let point = trip.points[trip.points.length - 1];
            points.push(point);
          }
          return 0;
        });
      }
      points.map(point => {
        this.getAddressFromWaypoint(point);
        return 0;
      });

      return points;
    }
  },

  watch: {
    lastWaypointUpdateTime () {
      this.monitorVehicles = this.vehicles;
      if (!this.isViewHistory) {
        this.drawMonitorMarkers();
      }
    },
    selectedVehicle () {
      if (!this.isDrawFinishMap) return;
      this.monitorFocusVehicle = this.selectedVehicle;
      // console.log('🚀 ~ file: map.vue ~ line 292 ~ selectedVehicle ~ this.selectedVehicle', this.monitorMarkers[this.selectedVehicle.id])
      if (!this.isViewHistory) {
        this.jumpToSelectedVehicle(this.monitorFocusVehicle);
        let latLngs = [this.getLatLngFromWaypoint(this.monitorFocusVehicle.waypoint)];
        // eslint-disable-next-line
        let markerBounds = this.$leaflet.latLngBounds(latLngs);
        
        this.map.fitBounds(markerBounds, { maxZoom: 20 });

      } else {
        window.getApp.viewHistory();
      }
    },
    historyWaypoints () {
      this.drawHistory();
    },

    mapType () {
      this.map.removeLayer(this.mapLayer);
      this.mapLayer = this.createMapTileLayer(this.mapType);
      this.mapLayer.addTo(this.map);
    }
  },

  beforeDestroy () {
    this.SET_VIEW_HISTORY_DETAIL_STATE(false);
    this.SET_VIEW_HISTORY_STATE(false);
  },

  mounted () {
    this.SET_VIEW_HISTORY_STATE(false);
    this.SET_VIEW_HISTORY_DETAIL_STATE(false);
    this.map = this.$leaflet.map('map', {
      attributionControl: false,
      zoomControl: false
    }).setView(this.mapConfig.center, this.mapConfig.zoom);

    this.mapLayer = this.createMapTileLayer(this.mapType);
    this.mapLayer.addTo(this.map);
    this.map.on('click', e => {
      this.display.showPopup = false;
    });

    if (this.vehicles.length > 0 && !!this.lastWaypointUpdateTime) {
      this.monitorVehicles = this.vehicles;
      this.drawMonitorMarkers();
    }

    setTimeout(() => {
      this.startGetWaypointsInterval();
    }, 100);
  },

  // async created () {
  // },

  destroyed () {
    clearInterval(this.monitorInterval);
  },

  methods: {
    ...mapActions(['getVehicleWaypoints', 'getUserInfo', 'stopSharingLocation', 'getVehicles']),
    ...mapMutations([
      'RESET_UTC_TICKS',
      'SET_SELECTED_VEHICLES',
      'SET_VIEW_HISTORY_STATE',
      'SET_VIEW_HISTORY_DETAIL_STATE',
      'SET_HISTORY_FROM_DATE',
      'SET_HISTORY_TO_DATE',
      'SET_WP_UPDATE_TIME',
      'SET_TOKEN'
    ]),

    getMaptypeName () {
      if (this.mapType === 'roadmap') {
        return 'hybrid';
      }
      return 'roadmap';
    },

    startGetWaypointsInterval () {
      this.RESET_UTC_TICKS();
      this.getVehicleWaypoints();
      if (this.monitorInterval == null) {
        this.monitorInterval = setInterval(() => {
          this.getVehicleWaypoints();
        }, this.monitorIntervalSecond);
      }
    },

    drawMonitorMarkers () {    
      this.removeAllMapLayer().then(_ => {
        // eslint-disable-next-line
        let markers = this.$leaflet.markerClusterGroup({
          showCoverageOnHover: false,
          removeOutsideVisibleBounds: true,
          spiderLegPolylineOptions: false
        });

        this.monitorVehicles.map(v => {
          if (v.waypoint != null) {
            const marker = this.getVehicleMarkerIcon(v);

            marker.on('click', e => {
              this.display.showPopup = true;
              this.bindMarkerPopup(v, marker);
              this.monitorFocusVehicle = v;
              this.SET_SELECTED_VEHICLES(v);
            });

            this.monitorMarkers[v.id] = marker;
            // marker.addTo(this.map);
            markers.addLayer(marker);

            if (this.monitorFocusVehicle === null && this.selectedVehicle === null && v.waypoint != null) {
              this.monitorFocusVehicle = v;
              this.SET_SELECTED_VEHICLES(v);
              this.jumpToSelectedVehicle(this.monitorFocusVehicle);
            }
          }
          return 0;
        });
        this.map.addLayer(markers);
        this.monitorMarkerCluster = markers;

        if (this.selectedVehicle) {
          let vehicle = this.monitorVehicles.filter(
            a => a.id === this.selectedVehicle.id
          )[0];

          this.monitorFocusVehicle = vehicle;
          if (this.display.showPopup) {
            this.jumpToSelectedVehicle(this.monitorFocusVehicle);
          }
        }
        this.isDrawFinishMap = true;
        this.showStatusSharing();
        return 0;
      });
    },

    jumpToSelectedVehicle (vehicle, marker) {
      // console.log('monitorMarkers', this.monitorMarkers);
      if (vehicle && vehicle.waypoint) {
        this.monitorFocusVehicle = vehicle;
        this.display.showPopup = true;

        this.map.setView(this.getLatLngFromWaypoint(vehicle.waypoint));

        this.bindMarkerPopup(vehicle, this.monitorMarkers[vehicle.id]);
      }
    },

    bindMarkerPopup (v, marker) {
      // console.log('🚀 ~ file: map.vue ~ line 477 ~ bindMarkerPopup ~ marker', marker)
      const plate = v.plate;
      let time = DateTimeUtil.formatSecondToGPSTime(v.waypoint.time);
      let status = this.getVehicleStatus(v);
      let latlng = this.getLatLngFromWaypoint(v.waypoint);
      let location = `${latlng.lat.toFixed(6)},${latlng.lng.toFixed(6)}`;
      let startTime = DateTimeUtil.formatSecondToHHmm(
        v.waypoint.dayState.startTime || 0
      );
      let runTime = DateTimeUtil.formatSecondToDuration(
        v.waypoint.dayState.runSeconds || 0
      );
      let idleTime = DateTimeUtil.formatSecondToDuration(
        v.waypoint.dayState.idleSeconds || 0
      );
      let mileage = v.waypoint.dayState.km.toFixed(2);
      let address = this.getAddressFromWaypoint(v.waypoint);
      let contentBattery = '';
      switch (v.deviceType) {
        case 'MTP8': {
          contentBattery += `<label class="battery"><span class="battery-border"><span class="battery-percent" style="width: ${v.waypoint && v.waypoint.battery}%"></span></span>${v.waypoint && v.waypoint.battery}%</label>`;
          break;
        }
        case 'MTP9': {
          let line = '<span class="battery-item"></span>';
          let remain = v.waypoint && v.waypoint.battery || 1;
          contentBattery += `<label class="battery"><span class="battery-border not-percent">${line.repeat(remain - 1)}</span></label>`;
          break;
        }
        default: break;
      }
      
      let content = `
            <h3 class="test">
              ${plate}
              ${contentBattery}
            </h3>
            <table>
              ${v.deviceType !== 'MTP8' ? `<tr>
                <td style='width: 90px; padding-bottom: 4px;'>Trạng thái</td>
                <td style='padding-bottom: 4px;'>${status}</td>
              </tr>` : ''}

              <tr>
                <td style='width: 90px; padding-bottom: 4px;'>Thời gian GPS</td>
                <td style='padding-bottom: 4px;'>${time}</td>
              </tr>
              <tr>
                <td style='width: 90px; padding-bottom: 4px;'>Địa chỉ</td>
                <td style='padding-bottom: 4px;'>${address}</td>
              </tr>
              <tr>
                <td style='width: 90px; padding-bottom: 4px;'>Vị trí</td>
                <td style='padding-bottom: 4px;'>${location}</td>
              </tr>
              <tr>
                <td style='width: 90px; padding-bottom: 4px;'>Bắt đầu</td>
                <td style='padding-bottom: 4px;'>${startTime}</td>
              </tr>
              <tr>
                <td style='width: 90px; padding-bottom: 4px;'>Di chuyển</td>
                <td style='padding-bottom: 4px;'>${runTime}</td>
              </tr>

              ${v.deviceType !== 'MTP8' ? `
              <tr>
                <td style='width: 90px; padding-bottom: 4px;'>Dừng</td>
                <td style='padding-bottom: 4px;'>${idleTime}</td>
              </tr>` : ''}
              
              <tr>
                <td style='width: 90px; padding-bottom: 4px;'>Quãng đường</td>
                <td style='padding-bottom: 4px;'>${mileage} Km</td>
              </tr>
            </table>
            <p style="text-align: center;">`;

      if (v.deviceType !== 'MTP8') {  // Check ẩn/hiện chức năng bật/tắt chống trộm đối với loại thiết bị MTP8
        content += `
              <button onclick="window.getApp.lock()" title="Bật chống trộm" type="button" class="small-button v-btn v-btn--icon theme--light"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--light">lock</i></div></button> 
              <button onclick="window.getApp.unLock()" title="Tắt chống trộm" type="button" class="small-button v-btn v-btn--icon theme--light"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--light">lock_open</i></div></button>
              `;
      }
      
      content += `<button onclick="window.getApp.viewHistory()" title="Xem lại lộ trình" type="button" class="small-button v-btn v-btn--icon theme--light"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--light">history</i></div></button> 
              <button onclick="window.location.href='#/reporting/dailybyvehicle'" title="Báo cáo" type="button" class="small-button v-btn v-btn--icon theme--light"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--light">bar_chart</i></div></button> 
              ${v.deviceType === 'MTP8' ? `<button onclick="window.getApp.updateWaypoint()" title="Cập nhật vị trí" type="button" class="small-button v-btn v-btn--icon theme--light"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--light">room</i></div></button>` : ''}
              <button onclick="window.location.href='#/maintenance?vehicleId=${this.selectedVehicle.id}'" type="button" title="Bảo trì - bảo dưỡng" class="small-button v-btn v-btn--icon theme--light"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--light">build</i></div></button>
            </p>
            `;

      let popup = marker.getPopup();
      
      if (v.isLocked) {
        content = 
        `<h3 style="color:red">${plate} (Tạm khóa)</h3>
        <p style="text-align:justify">Thiết bị lắp trên xe này hiện đang bị tạm ngưng dịch vụ do đã hết hạn sử dụng</p>
        <p style="text-align:justify">Để biết thêm thông tin về cước phí và cách gia hạn xin lòng liên lạc với chúng tôi qua tài khoản Zalo VIETMAP MOTRAK hoặc tổng đài hỗ trợ khách hàng 1900 633 378.</p>
        <p style="text-align:justify">Xin cảm ơn</p>
        <p style="text-align: center;">
          <button onclick="window.location.href='https://chat.zalo.me/?c=4677130402976150123'" target="_blank" type="button" class="white--text v-btn v-btn--round theme--light blue"><div class="v-btn__content">Liên hệ Zalo   Vietmap Motrak</div></button>
        </p>
        `;
      }

      if (popup !== undefined) {
        marker.unbindPopup();
      }
      // eslint-disable-next-line
      marker.bindPopup(content, { offset: new this.$leaflet.Point(0, -5) });

      if (this.display.showPopup) {
        marker.openPopup();
      }
    },

    // History
    removeAllMapLayer () {
      // if (this.monitorMarkers != null) {
      //   Object.keys(this.monitorMarkers).map((key, index) => {
      //     this.map.removeLayer(this.monitorMarkers[key]);
      //     return 0;
      //   });
      //   this.monitorMarkers = {};
      // }
      if (this.monitorMarkerCluster) {
        this.monitorMarkerCluster.clearLayers();
      }
      if (this.historyMapLayer.polyline) {
        this.map.removeLayer(this.historyMapLayer.polyline);
        this.historyMapLayer.polyline = null;
      }
      if (this.historyMapLayer.vehicleMarker) {
        this.map.removeLayer(this.historyMapLayer.vehicleMarker);
        this.historyMapLayer.vehicleMarker = null;
      }
      if (this.historyMapLayer.overspeedLines.length > 0) {
        this.historyMapLayer.overspeedLines.map(p => {
          this.map.removeLayer(p);
          return 0;
        });
      }
      if (this.historyMapLayer.stoppedMarkers.length > 0) {
        this.historyMapLayer.stoppedMarkers.map(marker => {
          this.map.removeLayer(marker);
          return 0;
        });
        this.historyMapLayer.stoppedMarkers = [];
      }
      this.monitorMarkers = {};
      this.historySlider.currentPoint = 0;
      this.clearSliderInterval();

      return new Promise(resolve => {
        resolve();
      });
    },

    drawHistory () {
      this.removeAllMapLayer();

      const points = [];

      if (this.historyWaypoints != null && this.historyWaypoints.length > 0) {
        this.historyWaypoints.map(wp => {
          const latlng = this.getLatLngFromWaypoint(wp);
          points.push(latlng);
          return 0;
        });

        // draw polyline
        // eslint-disable-next-line
        let polyline = new this.$leaflet.Polyline(
          points,
          this.mapType === 'hybrid'
            ? this.bluePolylineOption
            : this.greenPolylineOption
        );

        this.map.addLayer(polyline);
        this.map.fitBounds(polyline.getBounds());
        this.historyMapLayer.polyline = polyline;

        // draw stopped markers
        this.drawStoppedMarkers();

        // draw overspeed lines
        this.drawOverspeedLines();

        // draw move marker (vehicle)
        let vehicle = Object.assign({}, this.selectedVehicle);
        vehicle.waypoint = this.historyWaypoints[0];
        this.historyMapLayer.vehicleMarker = this.getVehicleMarkerIconForHistory(
          vehicle
        ).addTo(this.map);
      }
    },

    drawStoppedMarkers () {
      this.stoppedPoints.map((point, index) => {
        const latlng = this.getLatLngFromWaypoint(point);

        // eslint-disable-next-line
        let marker = this.$leaflet.marker(latlng, {
          icon:
            index > 0 && index < this.stoppedPoints.length - 1
              ? this.stoppedMarker
              : this.defaultMarker
        }).addTo(this.map);

        if (index === 0 || index === this.stoppedPoints.length - 1) {
          marker.bindTooltip(index === 0 ? 'Bắt đầu' : 'Kết thúc', {
            permanent: true,
            direction: 'bottom',
            opacity: 1,
            offset: [0, 5]
          });
        }

        let content = point.address;
        if (point.idle !== undefined && point.duration !== undefined) {
          content += `<br/> Dừng: ${point.idle}, từ ${point.duration}`;
        }

        // eslint-disable-next-line
        marker.bindPopup(content, { offset: new this.$leaflet.Point(0, -30) });

        marker.x = point.x;
        marker.y = point.y;

        this.historyMapLayer.stoppedMarkers.push(marker);
        return 0;
      });
    },

    drawOverspeedLines () {
      const lines = [];
      let points = [];

      if (this.historyWaypoints != null && this.historyWaypoints.length > 0) {
        for (let index = 0; index < this.historyWaypoints.length; index++) {
          const wp = this.historyWaypoints[index];

          if (wp.kmh > this.getVehicleLimitSpeed(this.selectedVehicle)) {
            const point = this.getLatLngFromWaypoint(wp);
            points.push(point);
          } else {
            if (points.length > 1) {
              lines.push(points);
              points = [];
            } else {
              points = [];
            }
          }
        }
        // draw polyline
        lines.map(line => {
          // eslint-disable-next-line
          const polyline = new this.$leaflet.Polyline(line, this.redPolylineOption);
          this.map.addLayer(polyline);
          this.historyMapLayer.overspeedLines.push(polyline);
          return 0;
        });
      }
    },

    playBack () {
      if (!this.historySlider.isPlayback) {
        if (this.historySlider.currentPoint === this.totalPoints) {
          this.historySlider.currentPoint = 0;
        }
        this.historyInterval = setInterval(() => {
          this.sliderValueChanged(this.historySlider.currentPoint);
          this.historySlider.currentPoint++;
          if (this.historySlider.currentPoint >= this.totalPoints) {
            this.clearSliderInterval();
          }
        }, 1000 / (this.historySlider.stepSpeed * 4));

        this.historySlider.isPlayback = true;
      } else {
        this.clearSliderInterval();
      }
    },

    clearSliderInterval () {
      clearInterval(this.historyInterval);
      this.historySlider.isPlayback = false;
    },

    sliderValueChanged () {
      let wp = this.historyWaypoints[this.historySlider.currentPoint];

      this.stoppedPoints.map((stoppedPoint, index) => {
        if (wp.x === stoppedPoint.x && wp.y === stoppedPoint.y && index > 0) {
          this.pauseForStoppedPoint();
        }
        return 0;
      });

      // set marker location
      this.historyMapLayer.vehicleMarker.setLatLng(
        this.getLatLngFromWaypoint(wp)
      );
      // set marker heading
      this.historyMapLayer.vehicleMarker.setRotationAngle(wp.heading);

      // set marker icon
      let vehicle = Object.assign({}, this.selectedVehicle);
      vehicle.waypoint = wp;
      let url = this.getVehicleIconForHistory(vehicle);
      // eslint-disable-next-line
      let icon = new this.$leaflet.Icon({
        iconUrl: url,
        iconSize: [50, 50]
      });
      this.historyMapLayer.vehicleMarker.setIcon(icon);

      // set marker popup
      let time = DateTimeUtil.formatSecondToHHmm(wp.time);
      let address = this.getAddressFromWaypoint(wp);

      const content = `
        Thời gian: ${time}, Vận tốc: ${wp.kmh} km/h<br/>
        Địa chỉ: ${address}
      `;

      let popup = this.historyMapLayer.vehicleMarker.getPopup();
      if (popup !== undefined) {
        this.historyMapLayer.vehicleMarker._popup.setContent(content);
      } else {
        this.historyMapLayer.vehicleMarker
          // eslint-disable-next-line
          .bindPopup(content, { offset: new this.$leaflet.Point(0, -10) })
          .openPopup();
      }
      const isMapContainsMarker = this.map
        .getBounds()
        .contains(this.historyMapLayer.vehicleMarker.getLatLng());
      if (!isMapContainsMarker) {
        this.map.setView(this.historyMapLayer.vehicleMarker.getLatLng());
      }
    },

    pauseForStoppedPoint () {
      let currentPoint = this.historyWaypoints[this.historySlider.currentPoint];
      let currentMarker = this.historyMapLayer.stoppedMarkers.filter(
        a => a.x === currentPoint.x && a.y === currentPoint.y
      )[0];

      this.playBack();
      this.map.closePopup();
      currentMarker.openPopup();
      if (this.historySlider.currentPoint < this.historyWaypoints.length - 1) {
        setTimeout(() => {
          this.historyMapLayer.vehicleMarker.openPopup();
          this.playBack();
        }, this.historyIdleTime);
      }
    },

    changeSpeed () {
      const isPlaying = this.historySlider.isPlayback;

      if (isPlaying) {
        this.historySlider.isPlayback = true;
        this.playBack();
      }

      if (this.historySlider.stepSpeed === 16) {
        this.historySlider.stepSpeed = 1;
      } else {
        this.historySlider.stepSpeed *= 2;
      }

      if (isPlaying) {
        this.playBack();
      }
    },

    closeHistory () {
      this.SET_VIEW_HISTORY_STATE(false);
      this.SET_VIEW_HISTORY_DETAIL_STATE(false);
      this.getVehicleWaypoints();
      this.drawMonitorMarkers();

      let latLngs = [this.getLatLngFromWaypoint(this.monitorFocusVehicle.waypoint)];
      // eslint-disable-next-line
        let markerBounds = this.$leaflet.latLngBounds(latLngs);
        
      this.map.fitBounds(markerBounds, { maxZoom: 19 });
      // this.SET_WP_UPDATE_TIME();
    },

    getMyLocation () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          if (this.myLocation.marker && this.myLocation.circle) {
            this.map.removeLayer(this.myLocation.marker);
            this.map.removeLayer(this.myLocation.circle);
          }

          this.display.showPopup = false;

          let latlng = [position.coords.latitude, position.coords.longitude];
          this.map.setView(latlng, 16);

          // eslint-disable-next-line
          let marker = this.$leaflet.marker(latlng, {
            icon: this.myLocationMarker
          }).addTo(this.map);

          // eslint-disable-next-line
          let circle = this.$leaflet.circle(
            latlng,
            100,
            this.myLocationFenceOption
          ).addTo(this.map);

          this.myLocation.marker = marker;
          this.myLocation.circle = circle;
        });
      }
    },
    showStatusSharing () {
      let start = DateTimeUtil.convertSecond2010ToDateTime(this.monitorFocusVehicle.waypoint.sharing.startTime);
      if (start < moment()) this.statusSharing = this.monitorFocusVehicle.waypoint.sharing.isSharing;
    },
    async stopSharedLocation () {
      let data = {
        code: this.monitorFocusVehicle.waypoint.sharing.code,
        vehicleId: this.selectedVehicle.id
      };
      let res = await this.stopSharingLocation(data).catch((err) => {
        console.log('err', err);
        return false;
      });
      if (!res) {
        window.getApp.showMessage('Có lỗi xảy ra, vui lòng thử lại', 'error');
        return;
      }
      this.statusSharing = false;
    },

    updateHistoryDateRange (val) {
      this.historyFromDate = val.startDate;
      this.historyToDate = val.endDate;
      this.historyMaxDay = 6;

      this.SET_HISTORY_FROM_DATE(this.historyFromDate);
      this.SET_HISTORY_TO_DATE(this.historyToDate);
      window.getApp.viewHistory();
    },

    selectHistoryDateRange (val) {
      this.historyMaxDay = moment(val.endDate).diff(moment(val.startDate), 'days');
      if (this.historyMaxDay > 6) {
        window.getApp.showMessage('Chọn ngày xem chi tiết hành trình không quá 7 ngày!', 'error');
      }
    }
  }
};
</script>

<style scoped>
#map {
    height: 100%;
    width: 100%;
    z-index: 3;
}
.wrap {
    height: 100%;
    width: 100%;
}
.player {
    bottom: 0 !important;
    position: absolute;
    z-index: 4;
}
.btn-change {
    margin-top: 3px;
    margin-left: -2px;
}
.md {
    width: calc(100% - 400px);
}
.lg {
    width: 640px;
    margin-left: calc((100% - 400px - 640px) / 2);
}
.historySlider {
    padding-left: 8px;
    padding-right: 8px;
    margin-top: 8px !important;
}
.date {
    margin-right: 12px;
}
.vdatetime {
    margin-right: -28px;
    color: #2b9bf4;
    font-size: 11pt;
}
.mini-text {
    font-size: 11pt;
}
.btn-location >>> .v-btn__content .v-icon {
  height: initial;
}
</style>

<style>
.small-button {
    margin: 4px;
}
#startDate {
    cursor: pointer;
}
#endDate {
    cursor: pointer;
}
.vdatetime-popup__header {
    padding: 15px 30px;
    background: #ffc107 !important;
    color: #fff;
    font-size: 32px;
}
.vdatetime-calendar__month__day--selected > span > span,
.vdatetime-calendar__month__day--selected:hover > span > span {
    color: #fff;
    background: #ffc107 !important;
}
.vdatetime-time-picker__item--selected {
    color: #ffc107 !important;
    font-size: 32px;
}
.vdatetime-popup__actions__button {
    display: inline-block;
    border: none;
    padding: 10px 20px;
    background: transparent;
    font-size: 16px;
    color: #444444 !important;
    cursor: pointer;
    -webkit-transition: color 0.3s;
    transition: color 0.3s;
    font-weight: bold;
}
.map-type {
    position: absolute;
    bottom: -2px;
    left: 4px;
    z-index: 3;
    cursor: pointer;
}

.get-location {
    position: absolute;
    bottom: 15px;
    right: 400px;
    z-index: 3;
    cursor: pointer;
}
.card-status{
  position: absolute;
  z-index: 401;
  border-radius: 30px;
  top: 10px;
  left: 10px;
}
.cancel-sharing{
  height: 24px !important;
  width: 24px !important;
}

.battery{
  float: right;
  font-size: 14px;
  display: block; 
  margin-top: 8px;
}
.battery-border{
  border: 1px solid #000;
  height: 12px;
  width: 26px;
  position: relative;
  display: inline-block;
  margin-right: 8px;
  border-radius: 2px;
}
.battery-border::before{
  content: '';
  width: 3px;
  height: 6px;
  position: absolute;
  right: -3px;
  top: 2px;
  background-color: #000;
}
.battery-border.not-percent{
  width: 23px;
}
.battery-percent{
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  margin: 1px;
  max-width: 26px;
  border-radius: 2px;
  background-color: #000;
}
.battery-item{
  position: absolute;
  top: 2px;
  bottom: 1px;
  width: 3px;
  background-color: #000;
}
.battery-item:nth-child(1){
  left: 1px;
}
.battery-item:nth-child(2){
  left: 5px;
}
.battery-item:nth-child(3){
  left: 9px;
}
.battery-item:nth-child(4){
  left: 13px;
}
.battery-item:nth-child(5){
  left: 17px;
}
.v-btn--floating .v-icon{
  height: auto !important;
}
.date-rangepicker{
  min-width: 270px;
}
.date-rangepicker .daterangepicker{
  top: auto;
  bottom: 40px;
}
.date-rangepicker .daterangepicker::before, .date-rangepicker .daterangepicker::after{
  display: none;
}
.date-rangepicker .reportrange-text{
  font-size: 14px;
  color: #2196f3;
  border: none !important;
  padding: 0 !important;
}
.date-rangepicker .yearselect{
  width: 80px;
}
.date-rangepicker .daterangepicker select{
  padding: 0 4px;
  -moz-appearance: auto;
  -webkit-appearance: auto;
}
.date-rangepicker .daterangepicker .applyBtn:disabled{
  opacity: 0.65;
}
.date-rangepicker.disabled-apply .daterangepicker .applyBtn{
  pointer-events: none;
  opacity: 0.65;
}
</style>



// WEBPACK FOOTER //
// src/pages/map/components/map.vue